export const CORPORATE_DATA = {
    facebookLink: `#`,
    instagrammLink: `#`,
    phoneNumbers: {
        eugene: `+16044408147`
    },
    address: ``,
    email: `info@codebridge.pro`,
    supportEmailData: {
        supportEmailSubject: `Code Bridge info`,
        supportEmailBody: `Hi Code Bridge team,`
    },
    companyTitle: `Code Bridge`,
    copyrightTitle: `Code Bridge`,
    locationPin: ``,
    locationPinShort: ``,
    formSendUrl: `https://codebridge-email-sender.herokuapp.com/email-sender`,
    imgBaseUrl: `https://objectstorage.ca-toronto-1.oraclecloud.com/p/jE02KCLipZSKqdPxfle5ABFxoo3kkhQaCZySIYDoeGA5vq21F6brBA1inVn0dds4/n/yzfveo9zjrvn/b/bucket-20230109-1321/o/codebridge/`
}